import { useEffect, useState } from "react";
import {
  getPeriodosAnexos,
  setProyectoActividadDesarrollo,
  updateCampo,
} from "../componentes/api.js";
import VerAnexosLista from "./VerAnexosLista.jsx";
import SubirArchivos from "./SubirArchivos.jsx";
import CheckIcon from "@mui/icons-material/Check";
import TextField from "@mui/material/TextField";
import CancelIcon from "@mui/icons-material/Cancel";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Evaluar from "../comun/Evaluar.jsx";
import { Alert, Form, Table } from "react-bootstrap";

const TablaDesarrollo = (props) => {
  const [periodos, setPeriodos] = useState([]);
  const [idProyectoActividadDesarrollo, setIdProyectoActividadDesarrollo] =
    useState("");
  const [cantRequerida, setCantRequerida] = useState(0);
  const [cantAnexa, setCantAnexa] = useState(0);
  const [actualizar, setActualizar] = useState("0");
  const [porc1, setPorc1] = useState(0);

  /***Para el manejo de la ventana para ver los anexos ****/
  const [verListaAnexos, setVerListaAnexos] = useState(false);

  /** Para el manejo de la ventana para subir archivos **/
  const [verVentanaSubir, setVerVentanaSubir] = useState(false);

  /** Para el manejo de la ventana para Calificar **/
  const [show3, setShow3] = useState(false);
  const handleClose3 = () => setShow3(false);

  const [archivoAnexo, setArchivoAnexo] = useState("");
  const [tipoArchivo, setTipoArchivo] = useState("");

  useEffect(() => {
    consultarDatos();
  }, [props.idParticipante]);

  const actualizarCampo = async (event, id) => {
    event.preventDefault();
    try {
      await updateCampo({
        tabla: "proyecto_actividad_desarrollo",
        campo: event.target.name,
        valor: event.target.value,
        id: id,
      });
    } catch (error) {
      console.log("Ocurrio un error al actualizar la Observación", error);
      props.mostrarMsg([
        "Ocurrio un error al actualizar la Observación",
        error,
      ]);
    }
  };

  const agregar = async (event) => {
    event.preventDefault();
    try {
      const resp = await setProyectoActividadDesarrollo({
        idProyectoActividad: props.idProyectoActividad,
        idParticipante: props.idParticipante,
      });
      if (resp.data.Id !== "") {
        consultarDatos();
      }
    } catch (error) {
      console.log("Ocurrio un error al cargar las Actividades", error);
      props.mostrarMsg([
        "Ocurrio un error al Agregar una Actividad al Proyecto",
        error,
      ]);
    }
  };

  const auditar = (id, estado) => {
    if (props.auditor === true) {
      //Es auditor
      return (
        <button
          className="btn btn-primary"
          onClick={(event) => {
            evaluar(event, id);
          }}
        >
          Auditar
        </button>
      );
    } else {
      //No es auditor
      if (estado === 1) {
        return (
          <p className="text-center">
            <VisibilityIcon />
            <br />
            Para Revisión
          </p>
        );
      } else if (estado === 2) {
        return (
          <p className="text-center">
            <CancelIcon />
            <br />
            Devuelta
          </p>
        );
      } else if (estado === 3) {
        return (
          <p className="text-center">
            <CheckIcon />
            <br />
            VoBo
          </p>
        );
      }
    }
  };

  const calcular = (periodos) => {
    setPorc1((periodos.length * 100) / props.anexosRequeridos);
  };

  const consultarDatos = async () => {
    try {
      const response = await getPeriodosAnexos({
        idProyectoActividad: props.idProyectoActividad,
        idParticipante: props.idParticipante,
      });
      setPeriodos(response.data);
      calcular(response.data);
    } catch (error) {
      props.mostrarMsg([
        "Ocurrio un error al cargar las Actividades del Proyecto",
        error,
      ]);
    }
  };

  const evaluar = (event, id) => {
    event.preventDefault();
    setIdProyectoActividadDesarrollo(id);
    setShow3(true);
  };

  const mostrarEstado = (estado) => {
    if (estado === 0) return "Registrado";
    else if (estado === 1) return "Para Revisión";
    else if (estado === 2) return "Devuelta";
    else if (estado === 3) return "VoBo";
  };

  const mostrarVentanaSubirArchivo = (event, id, cantRequerida, cantAnexa) => {
    event.preventDefault();
    setIdProyectoActividadDesarrollo(id);
    setCantRequerida(cantRequerida);
    setCantAnexa(cantAnexa);
    setVerVentanaSubir(true);
  };

  const verAnexos = (event, id) => {
    event.preventDefault();
    if (actualizar === "0") setActualizar("1");
    else setActualizar("0");
    setIdProyectoActividadDesarrollo(id);
    setVerListaAnexos(true);
  };

  return (
    <div className="container">
      <Table
        className="table table-hover caption-top"
        bordered
        hover
        size="sm"
        responsive
      >
        <caption>
          <Alert variant="info">
            <Alert.Heading>Listado de Actividades para realizar </Alert.Heading>
            <p className="mb-0">Anexos subidos: {periodos.length}</p>
            <button
              disabled={periodos.length >= props.anexosRequeridos}
              type="button"
              className="btn btn-primary"
              onClick={(event) => agregar(event)}
            >
              + Agregar Actividad
            </button>
          </Alert>
        </caption>

        <thead>
          <tr>
            <th scope="col"># Item</th>
            <th scope="col">Fecha de Realizada la Actividad</th>
            <th scope="col">Estado Actividad</th>
            <th scope="col">Motivo del Estado</th>
            <th scope="col">Adjuntar Archivo</th>
            <th scope="col">Anexos Subidos</th>
            <th scope="col">Visto Bueno</th>
          </tr>
        </thead>
        {periodos.map((reg, index) => {
          return (
            <tbody key={index}>
              <tr>
                <td>
                  <strong>{index + 1}</strong>
                </td>
                <td>
                  <Form.Control
                    type="date"
                    id="Fecha"
                    name="Fecha"
                    aria-describedby="Fecha"
                    defaultValue={
                      reg.Fecha !== null ? reg.Fecha.substring(0, 10) : ""
                    }
                    disabled={props.auditor}
                    onBlur={(event) => actualizarCampo(event, reg.Id)}
                  />
                </td>
                <td>{mostrarEstado(reg.Estado)}</td>
                <td>
                  {reg.Estado === 0 ? "Pendiente Revisión" : reg.MotivoEstado}
                </td>
                <td>
                  <button
                    disabled={props.auditor}
                    className="btn btn-primary form-control"
                    onClick={(event) =>
                      mostrarVentanaSubirArchivo(
                        event,
                        reg.Id,
                        reg.CantRequerida,
                        reg.CantAnexa
                      )
                    }
                  >
                    Anexar
                  </button>
                </td>
                <td>
                  <button
                    className="btn btn-primary form-control"
                    onClick={(event) => verAnexos(event, reg.Id)}
                  >
                    Ver
                  </button>
                </td>
                <td>{auditar(reg.Id, reg.Estado)}</td>
              </tr>

              <tr key={index}>
                <td colSpan={7}>
                  <p>Observaciones</p>
                  <TextField
                    disabled={props.auditor}
                    name="Observacion"
                    className="form-control"
                    type="text"
                    defaultValue={reg.Observacion}
                    onBlur={(event) => actualizarCampo(event, reg.Id)}
                  />
                </td>
              </tr>
            </tbody>
          );
        })}
      </Table>
      <h4>Porcentaje de Avance de la Actividad: {Math.round(porc1)}%</h4>

      {verListaAnexos === true && (
        <VerAnexosLista
          verListaAnexos={verListaAnexos}
          setVerListaAnexos={setVerListaAnexos}
          carpeta={"asesores/actividades"}
          idProyectoActividad={props.idProyectoActividad}
          idProyectoActividadDesarrollo={idProyectoActividadDesarrollo}
          idUsuario={props.idParticipante}
          archivo={archivoAnexo}
          tipoAnexo={tipoArchivo}
        />
      )}

      {verVentanaSubir === true && (
        <SubirArchivos
          verVentanaSubir={verVentanaSubir}
          setVerVentanaSubir={setVerVentanaSubir}
          cerrarAlGrabar={false}
          consultarAnexos={""}
          tituloAnexo={" en general"}
          Ruta={"asesores/actividades"}
          Id={props.idParticipante}
          Tabla={"proyecto_actividad_desarrollo_anexos"}
          Campo={"Ruta"}
          UsuarioReg={props.idParticipante}
          idProyectoActividad={props.idProyectoActividad}
          idUsuario={props.idParticipante} //voy por aqui
          mostrarMsg={props.mostrarMsg}
          idProyectoActividadDesarrollo={idProyectoActividadDesarrollo}
          consultarDatos={consultarDatos}
          cantRequerida={cantRequerida}
          cantAnexa={cantAnexa}
        />
      )}

      {show3 === true && (
        <Evaluar
          show={show3}
          handleClose={handleClose3}
          id={idProyectoActividadDesarrollo}
          idUsuario={props.idParticipante}
          consultarDatos={consultarDatos}
        />
      )}
    </div>
  );
};

export default TablaDesarrollo;
